import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { UserTypeEnum } from '../../enums/auth';
import { AuthUser, TermsAndConditionsChecksum } from '../../models/auth';

export const authEvents = eventGroup({
  source: 'Auth',
  events: {
    clear: type<void>(),
    setLoading: type<boolean>(),
    fleetlogin: type<{ username: string; password: string }>(),
    adminLogin: type<{ username: string; password: string }>(),
    freightLogin: type<{ username: string; password: string }>(),
    logout: type<void>(),
    signUp: type<{
      username: string;
      phoneNumber: string;
      email: string;
      password: string;
      givenName: string;
      userType: UserTypeEnum;
    }>(),
    signUpSuccess: type<void>(),
    resendConfirmationEmail: type<string>(),
    setConfirmationEmail: type<string>(),
    setChangePassEmail: type<string>(),

    getUser: type<{ accessToken: string | undefined }>(),
    loginSuccess: type<boolean>(),
    logoutSuccess: type<void>(),
    getUserSuccess: type<AuthUser>(),
    resetPassword: type<string>(),
    confirmPasswordReset: type<{
      code: string;
      email: string;
      newPassword: string;
    }>(),
    refreshSession: type<void>(),
    refreshSuccess: type<boolean>(),
    changePassword: type<{
      currentPassword: string;
      newPassword: string;
    }>(),
    respondToNewPasswordChalleng: type<{
      username: string;
      newPassword: string;
    }>(),
    updateUserAttrs: type<Record<string, any>>(),
    setResendConfirmation: type<boolean>(),
    acceptTerms: type<string>(),
    termsAccepted: type<boolean>(),
    loadTermsAndConditionsChecksum: type<void>(),
    loadedTermsAndConditionsChecksum: type<TermsAndConditionsChecksum | null>(),
    loadTermsAndConditionsPresignedUrl: type<void>(),
    loadedTermsAndConditionsPresignedUrl: type<string>(),
    updateTermsHashCommand: type<void>(),
  },
});
